import fp from 'lodash/fp';

export default keys => fp.pick(keys);



// WEBPACK FOOTER //
// ../pos-master/packages/pos-helper/src/mapState.js